import React from 'react';
import { Col, Form } from 'react-bootstrap';
import Select, { components } from 'react-select';

/* ---------- Custom Checkbox Option ---------- */
const CheckboxOption = (props) => {
  const { data, isSelected, selectProps } = props;
  const isChecked = data.value === '__ALL__' 
    ? selectProps.value.length === selectProps.options.length - 1
    : isSelected;

  return (
    <components.Option {...props}>
      <input type="checkbox" checked={isChecked} readOnly style={{ marginRight: 8, cursor: 'pointer' }} />
      {data.label}
    </components.Option>
  );
};

/* ---------- Custom Value Display ---------- */
const CustomValueContainer = ({ children, ...props }) => {
  const { getValue, selectProps } = props;
  const values = getValue();
  const totalOptions = selectProps.options.length - 1;

  if (!selectProps.isMulti) return <components.ValueContainer {...props}>{children}</components.ValueContainer>;

  if (values.length === totalOptions && totalOptions > 0) {
    return (
      <components.ValueContainer {...props}>
        <span style={{ fontSize: 13, fontWeight: 500, color: '#495057' }}>{selectProps.allLabel}</span>
      </components.ValueContainer>
    );
  }

  if (values.length > 0 && values.length <= 2) {
    return (
      <components.ValueContainer {...props}>
        <span style={{ fontSize: 13, color: '#495057' }}>{values.map(v => v.label).join(', ')}</span>
      </components.ValueContainer>
    );
  }

  if (values.length > 2) {
    return (
      <components.ValueContainer {...props}>
        <span style={{ fontSize: 13, color: '#6c757d' }}>{values.length} selected</span>
      </components.ValueContainer>
    );
  }

  return <components.ValueContainer {...props}>{children}</components.ValueContainer>;
};

/* ---------- Select All Handler ---------- */
const handleMultiChange = (selected, options) => {
  if (!selected) return [];
  const isSelectAllClicked = selected.some(opt => opt.value === '__ALL__');
  const allRealOptions = options.filter(opt => opt.value !== '__ALL__');

  if (isSelectAllClicked) {
    if (selected.length > allRealOptions.length) return [];
    return allRealOptions;
  }
  return selected;
};

const Filter = ({ fyOptions, locationOptions, periodOptions, intensityTypeOptions, filters, setFilters }) => {
  const styles = {
    control: (base) => ({ ...base, minHeight: 38, fontSize: 13, backgroundColor: '#fff' }),
    option: (base, state) => ({ ...base, backgroundColor: state.isFocused ? '#f8f9fa' : '#fff', color: '#212529', cursor: 'pointer', display: 'flex', alignItems: 'center' }),
    multiValue: () => ({ display: 'none' }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    placeholder: (base) => ({ ...base, fontSize: 13, color: '#6c757d' })
  };

  const withSelectAll = (options) => ([{ value: '__ALL__', label: 'Select All' }, ...options]);

  return (
    <>
      <Col md={2}>
        <Form.Group>
          <Form.Label className="small fw-bold">Financial Year</Form.Label>
          <Select options={fyOptions} value={filters.financialYear} onChange={(val) => setFilters({ ...filters, financialYear: val })} styles={styles} menuPortalTarget={document.body} />
        </Form.Group>
      </Col>
      <Col md={3}>
        <Form.Group>
          <Form.Label className="small fw-bold">Locations</Form.Label>
          <Select isMulti closeMenuOnSelect={false} hideSelectedOptions={false} options={withSelectAll(locationOptions)} value={filters.locations || []} onChange={(val) => setFilters({ ...filters, locations: handleMultiChange(val, withSelectAll(locationOptions)) })} components={{ Option: CheckboxOption, ValueContainer: CustomValueContainer }} allLabel="All Locations" placeholder="Select Locations" styles={styles} menuPortalTarget={document.body} />
        </Form.Group>
      </Col>
      <Col md={4}>
        <Form.Group>
          <Form.Label className="small fw-bold">Periods</Form.Label>
          <Select isMulti closeMenuOnSelect={false} hideSelectedOptions={false} options={withSelectAll(periodOptions)} value={filters.periods || []} onChange={(val) => setFilters({ ...filters, periods: handleMultiChange(val, withSelectAll(periodOptions)) })} components={{ Option: CheckboxOption, ValueContainer: CustomValueContainer }} allLabel="All Periods" placeholder="Select Periods" styles={styles} menuPortalTarget={document.body} />
        </Form.Group>
      </Col>
      <Col md={3}>
        <Form.Group>
          <Form.Label className="small fw-bold">Intensity Type</Form.Label>
          <Select options={intensityTypeOptions} value={filters.intensityType} onChange={(val) => setFilters({ ...filters, intensityType: val })} styles={styles} menuPortalTarget={document.body} placeholder="Select Type" />
        </Form.Group>
      </Col>
    </>
  );
};

export default Filter;